// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';
import './style.css';

export class FormCallbackBeforeFooter
{
	#app;
	constructor(rootNode): void
	{
		this.rootNode = document.querySelector(rootNode);
	}

	start(): void
	{
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		const formOptions = {
			phone: this.rootNode.dataset.phone || '',
			phoneCode: this.rootNode.dataset.phoneCode || '',
			workTime: this.rootNode.dataset.workTime || '',
		};

		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			data: () => ({
				formOptions,
			}),
			template: `
				<div>
					<Form
						:phone="formOptions.phone"
						:phone-code="formOptions.phoneCode"
						:work-time="formOptions.workTime"
					/>
				</div>
				`
		});
		this.#app.mount(this.rootNode);
	}
}
